
import React from "react";
import { Provider } from "react-redux";
import { store } from "./rtk-query/store";


export const ReduxProvider = (props) => {
  return <Provider store={store}> {props.children}</Provider>;
};
